<div class="tab-view-container">
  <div class="main-menu" role="tablist">
    @for (tab of tabs(); track tab.id) {
      @if (tab.type === 'community') {
        <button
          class="main-menu-button"
          role="tab"
          [class.active]="isTabActive(tab)"
          [attr.data-cy]="tab.dataCy"
          [attr.aria-selected]="isTabActive(tab)"
          (click)="onTabClick(tab)"
        >
          <div class="main-menu-icon-wrapper">
            <i class="main-menu-icon" [class]="tab.icon"></i>
            <span class="notification-dot" [class.visible]="hasUnreadCommunityThreads()" aria-hidden="true"></span>
          </div>
          @if (tab.caption) {
            <span class="main-menu-title">{{ tab.caption }}</span>
          } @else {
            <span class="main-menu-title" i18n="|Tab name">Community</span>
          }
        </button>
      } @else if (tab.type === 'search') {
        <button
          class="main-menu-button"
          role="tab"
          [class.active]="isTabActive(tab)"
          [attr.data-cy]="tab.dataCy"
          [attr.aria-selected]="isTabActive(tab)"
          (click)="onTabClick(tab)"
        >
          <div class="main-menu-icon-wrapper">
            <i class="main-menu-icon" [class]="tab.icon"></i>
          </div>
          @if (tab.caption) {
            <span class="main-menu-title">{{ tab.caption }}</span>
          } @else {
            <span class="main-menu-title" i18n="|Tab name">Search</span>
          }
        </button>
      } @else {
        <button
          class="main-menu-button"
          role="tab"
          [class.active]="isTabActive(tab)"
          [attr.data-cy]="tab.dataCy"
          [attr.aria-selected]="isTabActive(tab)"
          (click)="onTabClick(tab)"
        >
          <div class="main-menu-icon-wrapper">
            <i class="main-menu-icon" [class]="tab.icon"></i>
          </div>
          @if (tab.caption) {
            <span class="main-menu-title">{{ tab.caption }}</span>
          } @else {
            @switch (tab.type) {
              @case ('activities') {
                <span class="main-menu-title" i18n="|Tab name">Content</span>
              }
              @case ('skills') {
                <span class="main-menu-title" i18n="|Tab name">Skills</span>
              }
              @case ('groups') {
                <span class="main-menu-title" i18n="|Tab name">Groups</span>
              }
            }
          }
        </button>
      }
    }
  </div>
</div>
